// or get from process.env.REACT_APP_{var} to handle PROD and DEV environments
export const APP_VERSION: string = "2.0.0";
export const API_BASE_URL: string = "/api";
export const ENABLE_REDUX_LOGGER: boolean = false;

export const GQL_URI =
  process.env.REACT_APP_GRAPHQL_ENDPOINT || "http://localhost:8081/query";
export const REST_URI =
  process.env.REACT_APP_REST_ENDPOINT || "http://localhost:8081";

export const FAQ_URI =
  process.env.REACT_APP_FAQ_ENDPOINT || "https://localhost:1337/graphql";
export const MOCK_SECRET_PATH = "80c0e67ee3c745c081142a061ff6389c";

export const BITKUB_MENU_BOT_GRID_DISABLES: Array<string> = JSON.parse(
  process.env.REACT_APP_BITKUB_MENU_BOT_DISABLES || "[]"
);
